var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("template-card-v2", {
    attrs: {
      "one-log": _vm.oneLog,
      linkedtype: _vm.linkedtype,
      linkedid: _vm.linkedid
    },
    scopedSlots: _vm._u([
      {
        key: "icon",
        fn: function() {
          return [
            _c("CompassObject", {
              attrs: { object: "calendar", size: "small" }
            })
          ]
        },
        proxy: true
      },
      {
        key: "label",
        fn: function() {
          return [
            _c("person-list-light", {
              attrs: {
                list: _vm.oneLog.staffs.params.list,
                "placeholder-singular": "Collaborateur",
                "placeholder-plural": "Collaborateurs"
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c("div", [
              _c("div", { staticClass: "flex-level wp-10" }, [
                _c("div", { staticClass: "flex-column ovy-reset" }, [
                  _c(
                    "span",
                    { staticClass: "semibold lh-20 fs-3 flex-row ai-center" },
                    [
                      _c("CompassIcon", {
                        staticClass: "mr-1",
                        attrs: { size: "small", icon: "calendar-fill" }
                      }),
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$l10n.__("Pour le")) +
                          "\n                        " +
                          _vm._s(_vm.formatedDates[0]) +
                          "\n                        "
                      ),
                      _vm.formatedDates.length > 1
                        ? [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.formatedDates[2]
                                    ? _vm.$l10n.__("à")
                                    : _vm.$l10n.__("au")
                                ) +
                                "\n                            " +
                                _vm._s(_vm.formatedDates[1]) +
                                "\n                        "
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex-level" },
                    [
                      _vm.oneLog.label
                        ? _c(
                            "CompassTag",
                            {
                              staticClass: "event-card-tag",
                              attrs: {
                                type: "dot",
                                size: "small",
                                color: !!_vm.oneLog.labelColor.length
                                  ? "custom"
                                  : "yellow",
                                "custom-color": "#" + _vm.oneLog.labelColor
                              }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.oneLog.label) +
                                  "\n                        "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.oneLog.canSee,
                      expression: "oneLog.canSee"
                    }
                  ],
                  staticClass: "event-card-content__container"
                },
                [
                  _vm.oneLog.title
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "typographies-paragraph-medium-semibold event-card-title",
                          on: {
                            click: function($event) {
                              return _vm.previewEvent(_vm.oneLog)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.oneLog.title) +
                              "\n                "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.oneLog.description
                    ? _c("div", {
                        staticClass:
                          "typographies-paragraph-medium-regular event-card__content rich-text-style",
                        domProps: { innerHTML: _vm._s(_vm.oneLog.description) }
                      })
                    : _vm._e()
                ]
              )
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }